import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["gev19__contexthelp-text", _ctx.props.cssKlassen]),
    style: _normalizeStyle({
      cursor: _ctx.props.schliesstBeiKlickAufText === true ? 'pointer' : 'default',
    }),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.klickAufText()))
  }, [
    (_ctx.props.hatSchliessenButton)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "gev19__contexthelp-close",
          title: "Hilfe schließen",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.wechsleSichtbarkeit(_ctx.props.name)))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      innerHTML: _ctx.props.text
    }, null, 8, _hoisted_1),
    _renderSlot(_ctx.$slots, "default")
  ], 6)), [
    [_vShow, _ctx.istSichtbar(_ctx.props.name)]
  ])
}